module.exports = __webpack_public_path__ + "static/media/mps1_v4 copy.225812dc.jpg";